<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<script lang="ts">
  import {
    getDisplay,
    getValue,
    type GameraTeamReference,
  } from '@statmuse/core/gamera'
  import TeamPanel from '../common/team-panel.svelte'
  import { teamStats } from './stores'
  import Icon from '@components/icon.svelte'
  import TeamStats from './team-stats.svelte'

  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined

  let expanded = false

  $: awayTeamStats =
    $teamStats.away?.statsLookup[$teamStats.away?.statsLookupKey ?? '']
  $: homeTeamStats =
    $teamStats.home?.statsLookup[$teamStats.home?.statsLookupKey ?? '']

  $: awayTotalYds =
    getValue(awayTeamStats ?? {}, 'Passing-Yards') +
    getValue(awayTeamStats ?? {}, 'Rushing-Yards') -
    getValue(awayTeamStats ?? {}, 'Passing-SackYards')
  $: homeTotalYds =
    getValue(homeTeamStats ?? {}, 'Passing-Yards') +
    getValue(homeTeamStats ?? {}, 'Rushing-Yards') -
    getValue(homeTeamStats ?? {}, 'Passing-SackYards')

  $: awayTurnovers =
    getValue(awayTeamStats ?? {}, 'Passing-Interceptions') +
    getValue(awayTeamStats ?? {}, 'FumblesLost')
  $: homeTurnovers =
    getValue(homeTeamStats ?? {}, 'Passing-Interceptions') +
    getValue(homeTeamStats ?? {}, 'FumblesLost')
</script>

{#if Object.values(awayTeamStats ?? {}).length > 0 || Object.values(homeTeamStats ?? {}).length > 0}
  {#if expanded}
    <TeamStats {awayTeam} {homeTeam} />
  {:else}
    <TeamPanel {awayTeam} {homeTeam} title="Team Stats">
      <div
        class="border-t border-gray-6 dark:border-gray-4 divide-y divide-gray-6 dark:divide-gray-4 *:px-1 *:py-1"
      >
        {#if getDisplay(awayTeamStats ?? {}, 'Passing-Yards') || getDisplay(homeTeamStats ?? {}, 'Passing-Yards') || getDisplay(awayTeamStats ?? {}, 'Rushing-Yards') || getDisplay(homeTeamStats ?? {}, 'Rushing-Yards')}
          <div class="flex justify-center relative">
            <p
              class="absolute top-1 left-1 px-2 rounded-2xl"
              style={awayTotalYds > homeTotalYds
                ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {awayTotalYds}
            </p>
            <p class="text-gray-5">Total Yds</p>
            <p
              class="absolute top-1 right-1 px-2 rounded-2xl"
              style={homeTotalYds > awayTotalYds
                ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {homeTotalYds}
            </p>
          </div>
        {/if}

        {#if getDisplay(awayTeamStats ?? {}, 'TimeOfPossession') || getDisplay(homeTeamStats ?? {}, 'TimeOfPossession')}
          <div class="flex justify-center relative">
            <p
              class="absolute top-1 left-1 px-2 rounded-2xl"
              style={getValue(awayTeamStats ?? {}, 'TimeOfPossession') >
              getValue(homeTeamStats ?? {}, 'TimeOfPossession')
                ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {getDisplay(awayTeamStats ?? {}, 'TimeOfPossession')}
            </p>
            <p class="text-gray-5">Possession</p>
            <p
              class="absolute top-1 right-1 px-2 rounded-2xl"
              style={getValue(homeTeamStats ?? {}, 'TimeOfPossession') >
              getValue(awayTeamStats ?? {}, 'TimeOfPossession')
                ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {getDisplay(homeTeamStats ?? {}, 'TimeOfPossession')}
            </p>
          </div>
        {/if}

        {#if getDisplay(awayTeamStats ?? {}, 'FirstDowns') || getDisplay(homeTeamStats ?? {}, 'FirstDowns')}
          <div class="flex justify-center relative">
            <p
              class="absolute top-1 left-1 px-2 rounded-2xl"
              style={getValue(awayTeamStats ?? {}, 'FirstDowns') >
              getValue(homeTeamStats ?? {}, 'FirstDowns')
                ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {getDisplay(awayTeamStats ?? {}, 'FirstDowns')}
            </p>
            <p class="text-gray-5">1st Downs</p>
            <p
              class="absolute top-1 right-1 px-2 rounded-2xl"
              style={getValue(homeTeamStats ?? {}, 'FirstDowns') >
              getValue(awayTeamStats ?? {}, 'FirstDowns')
                ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {getDisplay(homeTeamStats ?? {}, 'FirstDowns')}
            </p>
          </div>
        {/if}

        {#if getDisplay(awayTeamStats ?? {}, 'ThirdDownConversions') || getDisplay(homeTeamStats ?? {}, 'ThirdDownConversions')}
          <div class="flex justify-center relative">
            <p
              class="absolute top-1 left-1 px-2 rounded-2xl"
              style={getValue(awayTeamStats ?? {}, 'ThirdDownConversions') >
              getValue(homeTeamStats ?? {}, 'ThirdDownConversions')
                ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {`${getDisplay(
                awayTeamStats ?? {},
                'ThirdDownConversions',
              )}/${getDisplay(awayTeamStats ?? {}, 'ThirdDownAttempts')}`}
            </p>
            <p class="text-gray-5">3rd Down</p>
            <p
              class="absolute top-1 right-1 px-2 rounded-2xl"
              style={getValue(homeTeamStats ?? {}, 'ThirdDownConversions') >
              getValue(awayTeamStats ?? {}, 'ThirdDownConversions')
                ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {`${getDisplay(
                homeTeamStats ?? {},
                'ThirdDownConversions',
              )}/${getDisplay(homeTeamStats ?? {}, 'ThirdDownAttempts')}`}
            </p>
          </div>
        {/if}

        {#if getDisplay(awayTeamStats ?? {}, 'RedZoneConversions') || getDisplay(homeTeamStats ?? {}, 'RedZoneConversions')}
          <div class="flex justify-center relative">
            <p
              class="absolute top-1 left-1 px-2 rounded-2xl"
              style={getValue(awayTeamStats ?? {}, 'RedZoneConversions') >
              getValue(homeTeamStats ?? {}, 'RedZoneConversions')
                ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {`${getDisplay(
                awayTeamStats ?? {},
                'RedZoneConversions',
              )}/${getDisplay(awayTeamStats ?? {}, 'RedZoneAttempts')}`}
            </p>
            <p class="text-gray-5">Red Zone</p>
            <p
              class="absolute top-1 right-1 px-2 rounded-2xl"
              style={getValue(homeTeamStats ?? {}, 'RedZoneConversions') >
              getValue(awayTeamStats ?? {}, 'RedZoneConversions')
                ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {`${getDisplay(
                homeTeamStats ?? {},
                'RedZoneConversions',
              )}/${getDisplay(homeTeamStats ?? {}, 'RedZoneAttempts')}`}
            </p>
          </div>
        {/if}

        {#if getDisplay(awayTeamStats ?? {}, 'Passing-Interceptions') || getDisplay(homeTeamStats ?? {}, 'Passing-Interceptions') || getDisplay(awayTeamStats ?? {}, 'Fumbles') || getDisplay(homeTeamStats ?? {}, 'Fumbles')}
          <div class="flex justify-center relative">
            <p
              class="absolute top-1 left-1 px-2 rounded-2xl"
              style={awayTurnovers < homeTurnovers
                ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {awayTurnovers}
            </p>
            <p class="text-gray-5">Turnovers</p>
            <p
              class="absolute top-1 right-1 px-2 rounded-2xl"
              style={homeTurnovers < awayTurnovers
                ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
                : undefined}
            >
              {homeTurnovers}
            </p>
          </div>
        {/if}

        <div class="flex justify-center relative text-gray-5">
          <p
            class="hidden @xl/boxscore:flex gap-1.5 items-center cursor-pointer"
            on:click={() => (expanded = true)}
          >
            <span>See more</span>
            <Icon name="dropdown" class="w-5 h-5 mt-0.5" />
          </p>
          <label
            for="team-stats"
            class="flex @xl/boxscore:hidden gap-1.5 items-center cursor-pointer"
            on:click={() => window.scrollTo(0, 0)}
          >
            <span>See more</span>
            <Icon name="next" class="w-5 h-5 mt-0.5" />
          </label>
        </div>
      </div>
    </TeamPanel>
  {/if}
{/if}
